﻿import {translation} from "@2d-front-monorepo/core";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import CreditCardProvider from "../enums/CreditCardProvider";

export function getCreditCardProviderName(provider: CreditCardProvider): string {
	switch (provider) {
		case 0:
			return "";
		case 1:
			return translation(PermitTranslations.payment_provider__credit_call);
		case 2:
			return translation(PermitTranslations.payment_provider__iecisa);
		case 3:
			return translation(PermitTranslations.payment_provider__elavon_santander);
		case 4:
			return translation(PermitTranslations.payment_provider__stripe);
		case 5:
			return translation(PermitTranslations.payment_provider__moneris);
		case 6:
			return translation(PermitTranslations.payment_provider__transbank);
		case 7:
			return translation(PermitTranslations.payment_provider__payu);
		case 8:
			return translation(PermitTranslations.payment_provider__paypal);
		case 9:
			return translation(PermitTranslations.payment_provider__niidea);
		case 10:
			return translation(PermitTranslations.payment_provider__debit_credit_card);
		case 11:
			return translation(PermitTranslations.payment_provider__mercadopago);
		case 13:
			return translation(PermitTranslations.payment_provider__windcave);
		default:
			return "";
	}
}
